"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/cms_service.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSDashboardService = void 0;
const cms_service_pb_1 = require("./cms_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.dashboard.v1.CMSDashboardService
 */
exports.CMSDashboardService = {
    typeName: "spwn.dashboard.v1.CMSDashboardService",
    methods: {
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.GetYoutubeAccount
         */
        getYoutubeAccount: {
            name: "GetYoutubeAccount",
            I: cms_service_pb_1.CMSDashboardServiceGetYoutubeAccountRequest,
            O: cms_service_pb_1.CMSDashboardServiceGetYoutubeAccountResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.GetOAuthRedirectUrl
         */
        getOAuthRedirectUrl: {
            name: "GetOAuthRedirectUrl",
            I: cms_service_pb_1.CMSDashboardServiceGetOAuthRedirectUrlRequest,
            O: cms_service_pb_1.CMSDashboardServiceGetOAuthRedirectUrlResponse,
            kind: protobuf_1.MethodKind.Unary,
            idempotency: protobuf_1.MethodIdempotency.NoSideEffects,
        },
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.CreateOAuthRefreshToken
         */
        createOAuthRefreshToken: {
            name: "CreateOAuthRefreshToken",
            I: cms_service_pb_1.CMSDashboardServiceCreateOAuthRefreshTokenRequest,
            O: cms_service_pb_1.CMSDashboardServiceCreateOAuthRefreshTokenResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.GetDashboardGraphGroups
         */
        getDashboardGraphGroups: {
            name: "GetDashboardGraphGroups",
            I: cms_service_pb_1.CMSDashboardServiceGetDashboardGraphGroupsRequest,
            O: cms_service_pb_1.CMSDashboardServiceGetDashboardGraphGroupsResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.GetDashboardGraphById
         */
        getDashboardGraphById: {
            name: "GetDashboardGraphById",
            I: cms_service_pb_1.CMSDashboardServiceGetDashboardGraphByIdRequest,
            O: cms_service_pb_1.CMSDashboardServiceGetDashboardGraphByIdResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.dashboard.v1.CMSDashboardService.GetFilterValues
         */
        getFilterValues: {
            name: "GetFilterValues",
            I: cms_service_pb_1.CMSDashboardServiceGetFilterValuesRequest,
            O: cms_service_pb_1.CMSDashboardServiceGetFilterValuesResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=cms_service_connect.js.map